"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classificationData = require("@seek/classification-data");

var getSummaryForIds = function getSummaryForIds(ids, itemNames) {
  var _getClassification;

  if (ids.length === 0) {
    return '';
  }

  return ids.length === 1 ? (_getClassification = (0, _classificationData.getClassification)(Number(ids[0]))) === null || _getClassification === void 0 ? void 0 : _getClassification.name() : "".concat(ids.length, " ").concat(itemNames);
};

var getClassSummary = function getClassSummary(_ref) {
  var classification = _ref.classification,
      subclassification = _ref.subclassification;
  var classificationIds = classification ? classification.split(',') : [];
  var subclassificationIds = subclassification ? subclassification.split(',') : [];

  if (classificationIds.length <= 1 && subclassificationIds.length === 1) {
    return getSummaryForIds(subclassificationIds, 'Sub-Classifications');
  }

  return getSummaryForIds(classificationIds, 'Classifications');
};

var titleCase = function titleCase(string) {
  return string.split(' ').map(function (part) {
    return part && "".concat(part[0].toUpperCase()).concat(part.slice(1));
  }).join(' ');
};

var _default = function _default(query, locale) {
  var keywords = query.keywords;
  var keywordSummary = keywords ? titleCase(keywords) : 'Jobs';
  var classSummary = keywords ? '' : getClassSummary(query);
  var what = keywordSummary + (classSummary ? " in ".concat(classSummary) : '');
  var where = query.where || (/^nz$/i.test(locale) ? 'NZ' : 'Australia');
  return "".concat(what, " in ").concat(where);
};

exports.default = _default;